import {
  GET_FILE_LIST,
  UPLOAD_FILE,
  IMPORT_FILE_DATA,
  UPLOAD_FILE_SET_LOADING,
  IMPORT_FILE_SET_LOADING,
  UPLOAD_FILE_ERROR,
  IMPORT_FILE_ERROR,
  DELETE_FILE,
  GET_FOUR_FIFTH_FILES,
  POST_FOUR_FIFTH_FILE,
  IMPORT_FOUR_FIFTH_FILE,
  IMPORT_FOUR_FIFTH_FILE_ERROR,
  POST_FOUR_FIFTH_FILE_ERROR, GET_FOUR_FIFTH_FILES_ERROR,
    CLEAR_ERROR
} from '../actions/types'
import {
  DELETE_IMPORTED_FOURTH_FIFTH_FILE, ERROR_DELETE_IMPORTED_FOURTH_FIFTH_FILE,
  GET_EXCEL_TEMPLATE,
  GET_FILES_TO_CALCULATE,
  GET_FILES_TO_CALCULATE_ERROR,
  MODIFY_SINGLE_FILE,
  POST_FILES_TO_CALCULATE,
  POST_FILES_TO_CALCULATE_ERROR
} from "../actions/actions";

const initialState = {
  uploadedFile: {},
  fileList: [],
  loading: false,
  importLoading: false,
  fileCalculation:[],
  error: null,
  importError: null,
  excel_template: null,
  fourFivesList:[],
  fourFivesSummary: null,
  error_msg: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_FILE_LIST:
      return {
        ...state,
        fileList: action.payload,
        loading: false
      };
    case IMPORT_FILE_DATA:
        return {
        ...state,
        file_data: action.payload,
        importLoading: false
      };
    case UPLOAD_FILE:
      let newFile = action.payload
      if(!newFile['date']) newFile['date'] = new Date()
      return {
        ...state,
        fileList:[newFile, ...state.fileList],
        uploadedFile: newFile,
        loading: false
      };
    case DELETE_FILE:
      return {
        ...state,
        fileList: state.fileList.filter(item => item.id!==action.id),
        uploadedFile: action.payload,
        loading: false
      }
    case GET_FILES_TO_CALCULATE:
      return {
        ...state,
        fileCalculation: action.payload,
        loading: false
      };
    case GET_FILES_TO_CALCULATE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    case MODIFY_SINGLE_FILE:
      return {
        ...state,
        fileCalculation: state.fileCalculation.map(file =>
          file.id === action.payload.id ? { ...action.payload } : file
        ),
      };
    case POST_FILES_TO_CALCULATE:
      return {
        ...state,
        fileCalculation: state.fileCalculation.map(file=>{if(file.id===action.payload.id){
          return action.payload
        }
        else{
          return file
        }
        }),
        importLoading: false,
        error: null
      };
    case POST_FILES_TO_CALCULATE_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        importLoading: false
      };
    case GET_EXCEL_TEMPLATE:
      return {
        ...state,
        excel_template: action.payload,
      };
    case UPLOAD_FILE_SET_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      }
    case IMPORT_FILE_SET_LOADING:
      return {
        ...state,
        importLoading: true,
        importError: null
      }
    case UPLOAD_FILE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      }
    case IMPORT_FILE_ERROR:
      return {
        ...state,
        importLoading: false,
        importError: true,
      }
    case GET_FOUR_FIFTH_FILES:
      return {
        ...state,
        fourFivesList: action.payload,
        loading: false
      };
    case POST_FOUR_FIFTH_FILE:
      return {
        ...state,
        fourFivesList:[action.payload, ...state.fourFivesList],
        loading: false
      };
    case IMPORT_FOUR_FIFTH_FILE:
      let newList 
      return {
        ...state,
        fourFivesList:state.fourFivesList.map(file=>{if(file.id===action.id){
          newList = file
          newList.data_imported = true
          newList.import_details = action.payload
          return newList
        }
        else{
          return file
        }
        }),
        importLoading: false,
        fourFivesSummary: action.payload
    };
    case GET_FOUR_FIFTH_FILES_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      }
    case POST_FOUR_FIFTH_FILE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      }
    case IMPORT_FOUR_FIFTH_FILE_ERROR:
      return {
        ...state,
        importLoading: false,
        error: true,
        error_msg: action.payload,
      }
    case CLEAR_ERROR:
    return {
         ...state,
        error: null,
        error_msg:null,
      }
    case DELETE_IMPORTED_FOURTH_FIFTH_FILE:
      return {
        ...state,
        fourFivesList: state.fourFivesList.filter(item => item.id!==action.payload),
      };
    case ERROR_DELETE_IMPORTED_FOURTH_FIFTH_FILE:
      return {
        ...state,
        error: true,
      }
    default:
      return state
  }
}

